<button class="category-filter"
    [class.active]="isActive"
    (click)="selected.emit(id)"
>
    {{ name }}
    <ng-container *ngIf="count">({{ count }})</ng-container>
</button>
